
import * as React from 'react';
import moment from 'moment';

function createWhatsAppLink(phone_Number) {
  let phoneNumber = phone_Number;

  if (phone_Number && phone_Number.includes('/')) {
    phoneNumber = phone_Number.split('/')[0];
  }
  if (phoneNumber) {
    // Remove any non-digit characters from the phone number
    const cleanedPhoneNumber = phoneNumber && phoneNumber.replace(/\D/g, '');

    // Check if the phone number starts with a '+' sign, if not, add it
    const formattedPhoneNumber = cleanedPhoneNumber.startsWith('+') ? cleanedPhoneNumber : `+${cleanedPhoneNumber}`;

    // Construct the WhatsApp link
    const whatsappLink = `https://wa.me/${formattedPhoneNumber}`;

    return whatsappLink;
  }
  return null;
}

export const clientsConfig = {
  api: () => '/clients',
  title: 'Clients',
  isActionTab: true,
  modalTitle: (action) => `${action}  Clients`,
  getColumns: () => {
    return [
      {
        title: 'Company Name',
        dataIndex: 'company',
        key: 'company',
        render: (text) => {
          return text.companyName;
        }
      },
      {
        title: 'Contact Name',
        dataIndex: 'contactPerson',
        key: 'contactPerson',
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: 'Contact Type',
        dataIndex: 'contactType',
        key: 'contactType',
      },
      {
        title: 'Whatsapp',
        dataIndex: 'phone',
        key: 'phone',
        render: (text) => <a href={createWhatsAppLink(text)} target="_blank" rel="noreferrer">{text}</a>
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Requirement Sharing On',
        dataIndex: 'requirementSharingBy',
        key: 'requirementSharingBy',
        isSearch: true,
      },
      {
        title: 'Added By',
        dataIndex: 'addedBy',
        key: 'addedBy',
        render: (text) => {
          return text ? [text.firstName, text.lastName].join(' ') : '';
        }
      },
      {
        title: 'Updated By',
        dataIndex: 'updatedBy',
        key: 'updatedBy',
        render: (text) => {
          return text ? [text.firstName, text.lastName].join(' ') : '';
        }
      },
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (text) => {
          return moment(text).format('lll');
        }
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Company Name',
        dataIndex: 'company',
        key: 'company',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Requirement Sharing Over',
        dataIndex: 'requirementSharingBy',
        key: 'requirementSharingBy',
        type: 'select',
        children: ['Email', 'Whatsapp', 'Phone', 'Linkedin', 'Upwork', 'Freelancer', 'Other'].map(ele => ({ name: ele, value: ele })),
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Contact Person',
        dataIndex: 'contactPerson',
        key: 'contactPerson',
        type: 'text',
        formClassName: 'col-4 pb-2',
      },
      // {
      //   title: "IS Vendor",
      //   dataIndex: "isVendor",
      //   key: "isVendor",
      //   type: "select",
      //   children: [{ name: 'yes', value: 'yes' }, { name: 'no', value: 'no' }],
      //   formClassName: "col-4 pb-2",
      // },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
        type: 'text',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        type: 'text',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Designation',
        dataIndex: 'contactPersonRole',
        key: 'contactPersonRole',
        type: 'select',
        children: [
          'CEO',
          'BDE',
          'Developer',
          'Freelancer',
          'HR',
          'Recruiter',
          'Project Manager',
          'Other'
        ].map(ele => ({ name: ele, value: ele })),
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Profile Link',
        dataIndex: 'profileLink',
        key: 'profileLink',
        type: 'text',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Contact Type',
        dataIndex: 'contactType',
        key: 'contactType',
        type: 'select',
        children: [
          'Client',
          'Vendor',
          'Both',
        ].map(ele => ({ name: ele, value: ele })),
        formClassName: 'col-4 pb-2',
      },
    ];
  },
  combo: [
    {
      name: 'company',
      api: '/organizations',
      idKey: '_id',
      nameKey: ['companyName'],
    },
  ],
  getData: () => ({}),
  actions: [
    {
      name: 'Filter', isFilter: true, otherFilter: true, form: {
        getFormColumns: () => {
          return [
            {
              title: 'Company Name',
              dataIndex: 'company',
              key: 'company',
              isRequired: true,
              isCombo: true,
              type: 'select',
              formClassName: 'col-4 pb-2',
            },
          ];
        },
        combo: [
          {
            name: 'company',
            api: '/organizations',
            idKey: '_id',
            nameKey: ['companyName'],
          },
        ],
      }
    },
    {
      name: 'Import', isImport: true, settings: { type: 'primary' },
      form: {
        api: () => '/clients/import',
        getFormColumns: () => {
          return [
            {
              title: 'Client List',
              dataIndex: 'file',
              key: 'file',
              isRequired: true,
              isCombo: false,
              type: 'file',
              formClassName: 'col-4 pb-2',
            },
          ];
        },
        combo: [],
      }
    },
    { name: 'Add Client', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};


// {
//   name: "Filter", isFilter: true, otherFilter: true, form: {
//     getFormColumns: () => {
//       return [
//         {
//           title: "Bill From",
//           dataIndex: "billFrom",
//           key: "billFrom",
//           type: "select",
//           isCombo: true,
//           formClassName: "col-4 pb-2",
//         },
//         {
//           title: "Bill To",
//           dataIndex: "billTo",
//           key: "billTo",
//           type: "select",
//           isCombo: true,
//           formClassName: "col-4 pb-2",
//         },
//       ]
//     },
//     combo: [
//       {
//         name: "billTo",
//         api: "/projects",
//         idKey: "_id",
//         nameKey: ["name", "clientName"],
//       },
//       {
//         name: "billFrom",
//         api: "/accounts",
//         idKey: "_id",
//         nameKey: ["beneficiaryName", "ifscNumber"],
//       },
//     ],
//   }
// },